/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSEmbedSessionRequest
 */
export interface CreateSEmbedSessionRequest {
    /**
     * Opt into the full S app contract. Requires S.FullAppEnabled in the backend configuration.
     * @type {boolean}
     * @memberof CreateSEmbedSessionRequest
     */
    fullApp?: boolean;
    /**
     * Expected saved business context for a full-app request. A different saved context returns 409.
     * @type {string}
     * @memberof CreateSEmbedSessionRequest
     */
    businessContext?: string;
    /**
     * Expected business scope. Full-app sessions use the saved context, not these IDs, for access.
     * @type {Array<string>}
     * @memberof CreateSEmbedSessionRequest
     */
    businessIds: Array<string>;
    /**
     * The host's saved interface language. Full-app sessions show it as the selected option of S's language picker. Defaults to en.
     * @type {string}
     * @memberof CreateSEmbedSessionRequest
     */
    language?: CreateSEmbedSessionRequestLanguageEnum;
}


/**
 * @export
 */
export const CreateSEmbedSessionRequestLanguageEnum = {
    en: 'en',
    ar: 'ar'
} as const;
export type CreateSEmbedSessionRequestLanguageEnum = typeof CreateSEmbedSessionRequestLanguageEnum[keyof typeof CreateSEmbedSessionRequestLanguageEnum];

/**
 * Check if a given object implements the CreateSEmbedSessionRequest interface.
 */
export function instanceOfCreateSEmbedSessionRequest(value: object): value is CreateSEmbedSessionRequest {
    if (!('businessIds' in value) || value['businessIds'] === undefined) return false;
    return true;
}

export function CreateSEmbedSessionRequestFromJSON(json: any): CreateSEmbedSessionRequest {
    return CreateSEmbedSessionRequestFromJSONTyped(json, false);
}

export function CreateSEmbedSessionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSEmbedSessionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fullApp': json['fullApp'] == null ? undefined : json['fullApp'],
        'businessContext': json['businessContext'] == null ? undefined : json['businessContext'],
        'businessIds': json['businessIds'],
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function CreateSEmbedSessionRequestToJSON(json: any): CreateSEmbedSessionRequest {
    return CreateSEmbedSessionRequestToJSONTyped(json, false);
}

export function CreateSEmbedSessionRequestToJSONTyped(value?: CreateSEmbedSessionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fullApp': value['fullApp'],
        'businessContext': value['businessContext'],
        'businessIds': value['businessIds'],
        'language': value['language'],
    };
}

